const calculateLtv = ({
  lookingTo,
  amountOfCashOut,
  existingLoanBalance,
  price,
  downPayment,
}) => {
  if (lookingTo === "RefinanceAndCashOut") {
    return ((+existingLoanBalance + +amountOfCashOut) / +price) * 100;
  } else if (lookingTo === "Refinance") {
    return (+existingLoanBalance / +price) * 100;
  } else {
    return ((+price - +downPayment) / +price) * 100;
  }
};

export default calculateLtv;
